// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1pqSL","label":"Completed_label__3He98"};